import React from "react"

const MapSlot = () => {
  return (
    <div className="w-full h-full bg-gradient-to-br from-bg-secondary to-surface-soft relative flex flex-col items-center justify-center gap-3">
      <svg className="absolute inset-0 w-full h-full opacity-20" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path
              d="M 40 0 L 0 0 0 40"
              fill="none"
              stroke="rgb(var(--app-base-strong))"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
      <div className="relative z-10 flex flex-col items-center gap-2">
        <div className="w-14 h-14 rounded-full bg-white shadow-lg flex items-center justify-center">
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
            <path
              fill="rgb(var(--app-base-strong))"
              d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
            />
          </svg>
        </div>
        <p className="text-sm font-semibold text-app-content">Google Maps</p>
      </div>
    </div>
  )
}

export default MapSlot
